import { css } from 'styled-components';

export default (thickness: '1px' | '2px') => css`
    box-shadow: 0 0 0 1px var(--border-color) ${thickness === '2px' ? ', inset 0 0 0 1px var(--border-color)' : ''};
`;
